import { render, staticRenderFns } from "./Postoperatorio.vue?vue&type=template&id=513b1046&"
import script from "./Postoperatorio.vue?vue&type=script&lang=js&"
export * from "./Postoperatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports